<template>
	<span>
    <Upload
			style="display: inline-block; width: 100px;"
			:action="'http'"
			:before-upload="handleUpload"
			:show-upload-list="false"
    >
		<Button icon="ios-camera">选择图片</Button>
    </Upload>
			<Poptip 
				content="content" 
				placement="bottom" 
				width="400"
				v-model="visible"
				:transfer="transfer"
			>
				<Button class="mr-1" v-show="file" type="info" icon="ios-eye-outline" ref="previewImageTheButton">预览图片</Button>
				<div class="api" slot="content">
				<img :src="avatar" class="img-avatar" width="200px" />
				</div>
			</Poptip>
    	<Button v-show="file" type="error" icon="md-trash" @click="clear">清除图片</Button>
    </span>
</template>
<script>
export default {
	props: {
		title: {
			type: String
		},
		imgname: {
			type: String
		},
		fix_modal: {
			type: Boolean
		},
		_class: { // 上傳id參數
			type: [String, Number]
		},
		transfer: {
			type: Boolean,
			default: true
		}
	},
	data() {
		return {
			file: null,
			avatar: null,
			visible: false,
			imageAction: `${process.env.VUE_APP_IMAGE_URL}/imgupdatejson.php`
		}
	},
	watch: {
		fix_modal(val) {
			if(!val) {
				this.file = null
				this.avatar = null
				this.visible = false
			}
		}
	},
	methods: {
		handleUpload(file) {
			this.file = file
			this.$emit('pushImageList', { file: file, _class: this._class })
			var reader = new FileReader()
			var that = this
			reader.readAsDataURL(file)
			reader.onload = function(e) {
				that.avatar = e.target.result
				that.$refs.previewImageTheButton.$el.click()
			}
			return false;
		},
		clear () {
			this.file = null
			this.$emit('removeImageList', this._class)
		}
	}
}
</script>